import { render, staticRenderFns } from "./FreightTableValorSaidaVeiculo.vue?vue&type=template&id=4f7f2fb5&scoped=true"
import script from "./FreightTableValorSaidaVeiculo.vue?vue&type=script&lang=js"
export * from "./FreightTableValorSaidaVeiculo.vue?vue&type=script&lang=js"
import style0 from "./FreightTableValorSaidaVeiculo.vue?vue&type=style&index=0&id=4f7f2fb5&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f7f2fb5",
  null
  
)

export default component.exports